<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.mixins.BaseContent.extend({
  data() {
    return {
      barWidthUnit: '%',
      defaultRemainingBarStackColor: '#ececec',
      stripes: [1, 2, 3, 4, 5, 6],
    };
  },
  props: {
    height: { type: Number, required: false },
    percentage: { required: false },
    color: { type: String, required: false },
    backgroundColor: { type: String, required: false },
  },
  computed: {
    barStacks() {
      return this.getBarStacksWhenEntitiesNotFound();
    },
    remainingBarStackColor() {
      return this.backgroundColor || this.defaultRemainingBarStackColor;
    },
  },
  methods: {
    getStripeStyle(percentage, anything) {
      return {
        left: `${percentage * anything}%`,
      };
    },
    getBarStacksWhenEntitiesNotFound() {
      const totalBarPercentage = this.percentage;
      if (this.isBarEmpty(totalBarPercentage)) {
        return [{ percentage: 0, color: this.remainingBarStackColor, tooltip: this.tooltip }];
      }
      if (this.isBarFull(totalBarPercentage)) {
        return [{ percentage: this.percentage, color: this.color, tooltip: this.tooltip }];
      }

      return [{ percentage: this.percentage, color: this.color, tooltip: this.tooltip }, this.getRemainingBarStack(totalBarPercentage)];
    },
    getRemainingBarStack(totalBarPercentage) {
      return { percentage: this.getRemainingPercentage(totalBarPercentage), color: this.remainingBarStackColor };
    },
    getRemainingPercentage(total) {
      return 100 - total;
    },
    isBarFull(total) {
      return total === 100;
    },
    isBarEmpty(total) {
      return total === 0;
    },
    hasSingleBarStack() {
      return this.barStacks.length === 1;
    },
    isLastBarStack(index) {
      return this.barStacks.length - 1 === index;
    },
    isFirstBarStack(index) {
      return index === 0;
    },
    isMiddleBarStack(index) {
      return index > 0 && index < this.barStacks.length - 1;
    },
    getBarStackClasses(index) {
      const classes = [];
      if (!this.hasSingleBarStack()) {
        classes.push('progress-bar-stack');
        if (this.isFirstBarStack(index)) {
          classes.push('first-progress-bar-stack');
        }
        if (this.isLastBarStack(index)) {
          classes.push('last-progress-bar-stack');
        }
        if (this.isMiddleBarStack(index)) {
          classes.push('middle-progress-bar-stack');
        }
        return classes;
      }
      return classes;
    },
    getBarStackStyleWidth(item) {
      if (item.percentage === 0 && this.hasSingleBarStack()) {
        return {
          width: 100 + this.barWidthUnit,
        };
      }
      return {
        width: item.percentage + this.barWidthUnit,
      };
    },
  },
});
</script>
<template>
  <div class="cly-progress-bar-container">
    <div />
    <div style="display: flex; justify-content: space-between; position: relative; top: 8px;">
      <div
        v-for="(anything, index) in stripes"
        :key="index"
        class="progress-bar-stripe"
        :style="index === 0 ? 'margin-left: 20px;' : '' || index === 5 ? 'margin-right: 20px;' : ''"
        style="box-shadow: inset 0 1px 3px 0 #9CBCE0;"
      />
    </div>
    <template v-for="(item, index) in barStacks">
      <div
        v-if="item.tooltipMode !== 'popover'"
        :key="index"
        class="cly-progress-bar-stack-container"
        :style="getBarStackStyleWidth(item)"
      >
        <el-progress
          :class="getBarStackClasses(index)"
          :show-text="false"
          :stroke-width="height"
          :percentage="percentage === 0 ? 100 : 100"
          :color="item.color"
          :style="{ 'z-index': percentage === 0 ? 0 : (index === 0 ? '2' : ''), height: '5px' }"
        />
      </div>
    </template>
  </div>
</template>
<style>
.progress-bar-stripe {
  width: 1px;
  height: 8px;
  background-color: #99C2EF;
  z-index: 1;
}
</style>
